
import './App.css';
import TextUtils from './TextUtils/TextUtils';

function App() {
  return (
    <>
    <TextUtils/>
    </>
  );
}

export default App;
